// import Pagination from "src/components/Pagination";
import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import toast from "react-hot-toast";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { GetAsoEbiAttires } from "src/graphql/queries";
import DashboardLayout from "src/layouts/dashboard";
import { ChevronLeftIcon } from "src/layouts/dashboard/Icons/AccessControlIcon";
import useAppStore from "src/store/utils";
import {
  GetAseobiAttires,
  GetAseobiAttiresVariables,
} from "src/utils/gql_types";
import Attires from "./Attires";
import EmptyState from "./EmptyState";

function useLocationQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

function AsoEbiGroup() {
  const { event } = useAppStore((state) => state);
  const navigate = useNavigate();

  const { groupId } = useParams();
  let query = useLocationQuery();
  const groupName = query.get("groupName");

  const { data: asoebiAttires, loading: asoebiAttiresLoading } = useQuery<
    GetAseobiAttires,
    GetAseobiAttiresVariables
  >(GetAsoEbiAttires, {
    variables: {
      event_id: event.uuid,
      aseobi_id: groupId ?? "",
    },
    fetchPolicy: "cache-first",
    onError(error) {
      if (error?.message !== "unauthenticated") {
        toast.error(<p>{error?.message ?? "An error occurred"}</p>);
      } else {
        navigate("/clear");
      }
    },
  });

  return (
    <DashboardLayout pageName="Aso Ebi">
      <section className="mx-auto w-[96%]">
        <header className="space-y-4 pt-8">
          <Link to="/aso-ebi" className="group flex w-fit items-center gap-2">
            <span className="transition duration-300 group-hover:-translate-x-2">
              <ChevronLeftIcon />
            </span>
            <span className="text-[#787777] transition-all duration-300 group-hover:font-semibold">
              Back
            </span>
          </Link>
          {asoebiAttires?.getAseobiAttires.length === 0 && (
            <h2 className="text-[22px] font-semibold">
              {groupName === "regular" ? `Regular` : groupName}
            </h2>
          )}
        </header>
        {asoebiAttires?.getAseobiAttires.length !== 0 ? (
          <Attires
            groupId={groupId}
            groupName={groupName}
            attires={asoebiAttires?.getAseobiAttires}
            loading={asoebiAttiresLoading}
          />
        ) : (
          <EmptyState groupId={groupId} groupName={groupName} />
        )}
      </section>
    </DashboardLayout>
  );
}

export default AsoEbiGroup;
